var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('utility-list-link',{ref:"utilityListLink",attrs:{"listLayout":_vm.listLayout,"utilityData":_vm.List,"paginationData":_vm.filterSet.page}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout,"paginationData":_vm.filterSet.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }